import {
  ADD_ITEM_TO_MYLOFW,
  REMOVE_ITEM_FROM_MYLOFW,
  REQUESTING_FB_AUTH_ID,
  SET_FB_AUTH_ID,
  SET_INITIAL_MY_FLOW_STORE_DATA,
  UNSET_FB_AUTH_ID,
  SET_FETCHED_USER_TIMETABLE,
  SET_USER_LIST_TIMETABLE,
  LOADING_USER_LIST_TIMETABLE,
  SET_MY_FLOW,
} from "@flow/store/myflow/constants";
import { MyFlowPage } from "types/MyFlow";
import { USER_LOG_OUT } from "@flow/store/user/constants";
import { UNSET_AUTH } from "../auth/constants";

export interface MyFlowState {
  requesting: boolean;
  success: boolean;
  error: boolean;
  eventIdHashMap: any;
  scheduleIdList: Array<string>;
  /*facebook: {
    userId?: string;
    loading: boolean;
    success: boolean;
    error: boolean;
  },*/
  myFlowPage: MyFlowPage;
}

const initialState: MyFlowState = {
  requesting: false,
  success: false,
  error: false,
  eventIdHashMap: {},
  scheduleIdList: [],
  /*facebook: {
    userId: undefined,
    loading: false,
    success: false,
    error: false,
  },*/
  myFlowPage: {
    idList: [],
    loading: false,
    success: false,
    error: false,
  },
};

export const myFlowReducer = (state = initialState, action: any) => {
  const { type, itemId, userId, hashMapItems, timetable } = action;

  switch (type) {
    case SET_INITIAL_MY_FLOW_STORE_DATA: {
      return {
        ...state,
        eventIdHashMap: hashMapItems,
      };
    }

    case SET_MY_FLOW: {
      return {
        ...state,
        scheduleIdList: action.myFlow,
      };
    }

    case ADD_ITEM_TO_MYLOFW: {
      return {
        ...state,
        scheduleIdList: [...state.scheduleIdList, itemId],
      };
    }

    case REMOVE_ITEM_FROM_MYLOFW: {
      return {
        ...state,
        scheduleIdList: state.scheduleIdList.filter((id) => id !== itemId),
      };
    }

    case UNSET_AUTH: {
      return {
        ...state,
        scheduleIdList: [],
      };
    }

    case REQUESTING_FB_AUTH_ID: {
      //const { facebook } = state;
      return {
        ...state,
        /*facebook: {
          ...facebook,
          loading: true,
        },*/
      };
    }

    case SET_FB_AUTH_ID: {
      //const { facebook } = state;
      return {
        ...state,
        /*facebook: {
          ...facebook,
          loading: false,
          success: true,
          error: false,
          userId,
        },*/
      };
    }

    case UNSET_FB_AUTH_ID: {
      //const { facebook } = initialState;
      return {
        ...state,
        //facebook,
        scheduleIdList: [],
      };
    }

    case SET_FETCHED_USER_TIMETABLE: {
      const filteredList = timetable.filter(
        (id: string) => state.eventIdHashMap[id]
      );
      return {
        ...state,
        scheduleIdList: filteredList,
      };
    }

    case LOADING_USER_LIST_TIMETABLE: {
      return {
        ...state,
        myFlowPage: { ...state.myFlowPage, loading: true },
      };
    }

    case SET_USER_LIST_TIMETABLE: {
      const filteredList = timetable.filter(
        (id: string) => state.eventIdHashMap[id]
      );
      return {
        ...state,
        myFlowPage: {
          idList: filteredList,
          success: action.success,
          error: action.error,
          loading: false,
        },
      };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/myflow/reducer.ts